/* VitaWalk Meta Pixel layer + Klick-Weitergabe vom Advertorial.
   Die PIXEL_ID bleibt bewusst der Platzhalter, solange die offizielle
   Facebook & Instagram App den Pixel stellt. Beides zusammen feuert doppelt.
   Attribution (utm/click ids) liegt komplett in vw-attr.js. */
(function () {
  var PIXEL_ID = 'REPLACE_WITH_PIXEL_ID';

  /* ---------- 1. Klick-Parameter ----------
     Uebernimmt jetzt vw-attr.js: capture, cookie, URL-Reflect, Link-Dekoration und
     das Stempeln der Warenkorb-Attribute. Frueher stand die Logik hier, aber sie
     lief ins Leere: der Checkout-Permalink /cart/<id>:<qty> loescht bestehende
     Cart-Attribute, also kam nie etwas auf der Bestellung an. vw-attr.js haengt die
     Attribute direkt an den Permalink. Hier nichts mehr doppelt machen. */

  /* ---------- 2. Pixel, nur wenn oben eine echte ID steht ---------- */
  /* immer definiert, damit Seitencode gefahrlos vwTrack() rufen kann */
  window.vwTrack = function (event, params, opts) {
    if (window.fbq) window.fbq('track', event, params || {}, opts || {});
  };

  if (!/^[0-9]{5,}$/.test(PIXEL_ID)) return;

  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');

  var p = location.pathname;
  if (p.indexOf('of01') !== -1) {
    window.fbq('track', 'ViewContent', {
      content_name: 'VitaWalk Comfort', content_type: 'product',
      content_ids: ['flame'], value: 89.99, currency: 'EUR'
    });
  } else if (p.indexOf('/products/') !== -1) {
    window.fbq('track', 'ViewContent', {
      content_name: 'VitaWalk Comfort', content_type: 'product',
      content_ids: ['flame'], currency: 'EUR'
    });
  }
})();
